const SpatialReference = Object.freeze({
  GEOGRAPHIC: "GEOGRAPHIC",
  PROJECTED: "PROJECTED"
});
export default SpatialReference;